// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1ExRC","header":"ReportDetails_header__2Iqw8","title":"ReportDetails_title__1jvIf","left":"ReportDetails_left__2OWto"};